export enum PackagingTypes {
  YourPackaging = 'YOUR_PACKAGING'
}
